import React from 'react';
import '../Style/Home.css';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import swal from 'sweetalert';

function Home() {

   const messageSubscribe = () => {
    swal('LetsPeak', 'Gracias por unirte', 'success')
  };
    return (
        <div className="home">
            
                <section className="pitch">
                  <picture className="picture">
                    <img src="https://images.unsplash.com/photo-1603570823473-d29ba441835e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=376&q=80"/>
                  </picture>
                    <h1>Become a better speaker.</h1>
                    <h3>Practice English by staying with local speakers 😉.</h3>
                </section>

                <section className="formulario">
                  <h3>You look great speaking english</h3>
          
                  <div className="formulario_container">
          
                     <form action="https://formsubmit.co/orangeandpeople@gmail.com" method="POST">

                       <input type="text" placeholder="  Name" name="name" required></input>
                       <input type="email" placeholder="  Email" name="email" required></input>
                       <label>
                         <input type="checkbox" name="checkbox"></input>
                         <label>  I´m a teacher</label>
                       </label>
                       
                       <input type="hidden" name="_captcha" value="false" ></input>
                       <input type="hidden" name="_next" value="https://lets-peak.web.app/"></input>

                       <button type="submit" className="buttonSubscribe" onClick={messageSubscribe}>Join now</button>
                       <p>By joining you will receive a special invitation when we launch our service. <br/><br/>Gracias!❤️️</p>

                    </form>
                  </div>
                  <div className="icon">
                 <VerifiedUserIcon/>
                 </div>
                 <h4>Authentication for both students and hosts
                     for everyone's safety.</h4>
                </section>
            

            <section className="anfitrion">
              <h3>Earn money teaching english in your home, or wherever and whenever you want.</h3> 
              <picture className="photo_anfitrion">
                <source media="(min-width: 1000px)" srcSet="https://firebasestorage.googleapis.com/v0/b/lets-peak.appspot.com/o/toa-heftiba-A-pckCHQMrM-unsplash.jpg?alt=media&token=f48f995a-eed9-49a4-8236-8fe64cf3f5d1"></source>
                <img src="https://firebasestorage.googleapis.com/v0/b/lets-peak.appspot.com/o/monika-kozub-AFsL8o5EUms-unsplash.jpg?alt=media&token=ff1fd308-409a-46a2-9434-759522cd9a30"/> 
              </picture>
            </section>

            {/*<section className="shcools">
            
                  <h2>Let´sPeak para colegios.</h2>
                  <h3>Crea intercambios culturales
                  mientras los chicos se envuelven
                  en un entorno natural del idioma.
                  </h3>
              <picture className="photo_school">
                <source media="(min-width: 1000px)" srcSet="https://firebasestorage.googleapis.com/v0/b/lets-peak.appspot.com/o/leon-NdZ08c-zu0c-unsplash.jpg?alt=media&token=f649d2dd-73f0-400b-b7b5-ade09adbecc8"></source>
                <img src="https://firebasestorage.googleapis.com/v0/b/lets-peak.appspot.com/o/eliott-reyna-rkmMmxnqtfk-unsplash.jpg?alt=media&token=14b98190-8db5-43c4-b8b6-287c2beb1a1a"/>
              </picture>
              </section>*/}

            <section className="friends">
               <h1>Meet new friends.</h1>
                <picture className="photo_friends">
                <source media="(min-width: 1000px)" srcSet="https://firebasestorage.googleapis.com/v0/b/lets-peak.appspot.com/o/mira-kireeva-xTq26wLo5do-unsplash.jpg?alt=media&token=77b4d8ec-99f3-4632-9cef-28ca0b0d8865"></source>
               <img src="https://firebasestorage.googleapis.com/v0/b/lets-peak.appspot.com/o/background%20letspeak.jpg?alt=media&token=c2e02350-3a22-486f-8b73-096da309d73d"/>
               </picture>
            </section>
                 
            
            
        </div>
    )
}

export default Home
